import { PathMatch } from "react-router-dom";

export const getMatch = (matches: (PathMatch<string> | null)[]): PathMatch<string> | null | undefined => {    
    return matches.find((match) => match !== undefined && match !== null);
}
